import { OS_MAP } from 'bowser';

import { OperatingSystem } from '~/generated/graphql';

// Maps Bowser-driven OS name to GraphQL enum OS name
const OS_ENUM_MAP: Record<string, OperatingSystem> = {
  [OS_MAP.Android]: OperatingSystem.Android,
  [OS_MAP.iOS]: OperatingSystem.Ios,
  [OS_MAP.Windows]: OperatingSystem.Windows,
  [OS_MAP.MacOS]: OperatingSystem.Macos,
  [OS_MAP.ChromeOS]: OperatingSystem.Chromeos,
};

export default OS_ENUM_MAP;
